import { useState, useEffect } from "react";
import despia from "despia-native";

export function useDespia() {
  const isNative =
    typeof navigator !== "undefined" &&
    navigator.userAgent.toLowerCase().includes("despia");

  const [trackingDisabled, setTrackingDisabled] = useState<boolean | null>(null);
  const [isLoading, setIsLoading] = useState(isNative);

  useEffect(() => {
    if (!isNative) return;

    (async () => {
      try {
        const result = await despia("user-disable-tracking://", [
          "trackingDisabled",
        ]);
        setTrackingDisabled(result?.trackingDisabled === true);
      } catch {
        setTrackingDisabled(null);
      } finally {
        setIsLoading(false);
      }
    })();
  }, [isNative]);

  return { isNative, trackingDisabled, isLoading };
}
